import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from "react-router";
import { ColorModeProvider } from './components/common/color-mode.tsx';
import { Provider } from './components/common/provider.tsx';
import router from './routes/routes.tsx';

const queryClient = new QueryClient();
createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<Provider>
			<ColorModeProvider>
				<QueryClientProvider client={queryClient}>
					<RouterProvider router={router} />
					<ReactQueryDevtools />
				</QueryClientProvider>
			</ColorModeProvider>
		</Provider>
	</StrictMode>
);
